module.exports = __webpack_public_path__ + "static/media/home_page_cover.fe61af9d.png";